export default function normalizeAssetUrl(src?: string | null): string | null {
  if (!src) return null;

  // Se l'URL inizia con /uploads, punta al backend
  if (src.startsWith('/uploads/')) {
    const backendUrl = process.env.NEXT_PUBLIC_BACKEND_URL || 'http://localhost:5001';
    return `${backendUrl}${src}`;
  }

  // Se è già un URL completo, ritorna così com'è
  if (src.startsWith('http://') || src.startsWith('https://')) {
    return src;
  }

  // Altrimenti è un asset locale del frontend
  return src.startsWith('/') ? src : `/${src}`;
}